import { Component, EventEmitter, Inject, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { InjectionToken } from '@angular/core';
import { AiMessage, AiRendererDef, AiResultAction } from '../models';

export const AI_RENDERERS = new InjectionToken<AiRendererDef[]>('AI_RENDERERS');

@Component({
	selector: 'app-ai-transcript-outlet',
	templateUrl: './ai-transcript-outlet.component.html',
	styleUrls: ['./ai-transcript-outlet.component.scss']
})
export class AiTranscriptOutletComponent implements OnChanges {
	@Input() messages: AiMessage[] = [];
	@Output() action = new EventEmitter<AiResultAction>();
	@Input() addedIds: Set<string> | string[] = [];
	@Input() hidePhotoGridRenderer: boolean = false;

	@ViewChild('messagesContainer', {static: true}) containerRef: any;

	constructor(@Inject(AI_RENDERERS) private defs: AiRendererDef[]) {
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['messages']) {
			// Scroll to bottom when new message arrives
			setTimeout(() => {
				if (this.containerRef && this.containerRef.nativeElement) {
					this.containerRef.nativeElement.scrollTop = this.containerRef.nativeElement.scrollHeight;
				}
			}, 100);
		}
	}

	getRenderer(type: string) {
		const found = this.defs?.find(d => d.type === type);
		return found?.component || null;
	}

	emitAction(msg: AiMessage, evt: any) {
		const payload = {...(evt || {}), messageId: msg?.id} as AiResultAction & { messageId: string };
		this.action.emit(payload);
	}
}
